import { useState, useEffect } from 'react';
import { InteractiveMap } from './InteractiveMap';

interface LocationPickerProps {
  latitude: number;
  longitude: number;
  onChange: (lat: number, lon: number) => void;
}

export function LocationPicker({ latitude, longitude, onChange }: LocationPickerProps) {
  return (
    <div className="space-y-6">
      {/* Interactive Map with integrated coordinate input */}
      <InteractiveMap 
        latitude={latitude} 
        longitude={longitude} 
        onChange={onChange}
      />

      {/* Selected Coordinates Display */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4">
          <p className="text-xs font-medium text-amber-700 mb-1">Latitude</p>
          <p className="text-2xl font-bold text-amber-900">{latitude.toFixed(4)}°</p>
          <p className="text-xs text-amber-600 mt-1">{latitude >= 0 ? 'North' : 'South'}</p>
        </div>
        
        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-200 rounded-lg p-4">
          <p className="text-xs font-medium text-blue-700 mb-1">Longitude</p>
          <p className="text-2xl font-bold text-blue-900">{longitude.toFixed(4)}°</p>
          <p className="text-xs text-blue-600 mt-1">{longitude >= 0 ? 'East' : 'West'}</p>
        </div>
      </div>

      {/* Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="text-sm text-blue-900">
          <p className="font-medium mb-2">How to select location:</p>
          <ul className="list-disc list-inside space-y-1 text-blue-800">
            <li><strong>Click "Enter Coordinates"</strong> button on the map to input coordinates manually</li>
            <li><strong>Click on the map</strong> to select your project location</li>
          </ul>
          <p className="mt-3 text-blue-700">
            The platform will fetch <strong>real NASA satellite data</strong> for accurate solar analysis.
          </p>
        </div>
      </div>
    </div>
  );
}